export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./app.html?vue&type=template&id=0babfb86&"